export const DASHBOARD_SORT = {
  newest: "newest",
  oldest: "oldest",
  name: "name",
  size: "size",
} as const;

export type DashboardSort =
  (typeof DASHBOARD_SORT)[keyof typeof DASHBOARD_SORT];
